export default __webpack_public_path__ + "static/map-09004a54c7f4555896f425ee2572d1c2.jpg";